import { Tag } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'translations/hooks';

import {
  DefectReportStatus,
  DefectReportStatusSearchable,
} from 'business/quality-control/pages/defect-report-history/hooks/data/types';

export const StatusTag = ({ status }: { status: string }) => {
  const { t } = useTranslation();

  const color = useMemo(() => {
    if (status === DefectReportStatusSearchable.Terminated) {
      return {
        text: '#2966FF',
        background: '#D5EAFF',
        border: '#C0DBF6',
      };
    }

    if (status === DefectReportStatus.RepairDone) {
      return {
        text: '#01AB61',
        background: '#DDFFE4',
        border: '#C9FAD8',
      };
    }

    if (
      [
        DefectReportStatus.RepairInProgress,
        DefectReportStatus.ReportPending,
      ].includes(status as DefectReportStatus)
    ) {
      return {
        text: '#666666',
        background: '#EDEDED',
        border: '#D9D9D9',
      };
    }

    return {
      text: '#C67402',
      background: '#FFF8DD',
      border: '#F5E9BE',
    };
  }, [status]);

  return (
    <Tag
      style={{
        color: color.text,
        borderColor: color.border,
        backgroundColor: color.background,
        borderRadius: 10,
      }}
    >
      <span>&#x25CF; </span>
      {t(`qualityControl.defectReportHistory.status.state`, {
        context: status,
      })}
    </Tag>
  );
};
